module.exports = __webpack_public_path__ + "static/media/palette.56add4df.svg";